import axios from "axios";
import { create } from "zustand";

export let useExpenses = create((set, get) => ({
    expenses: [],
    getExpenses: () => {
        axios.get('expenses').then(res => {
            set({ expenses: res.data })
        })
    },
    addExpenses: (expenses) => {
        axios.post('expenses', expenses).then(res => {
            set({ expenses: [...get().expenses, res.data] })
        })
    },
    updateExpenses: (expenses) => {
        axios.put(`expenses/${expenses.id}`, expenses).then(res => {
            set({ expenses: get().expenses.map(expense => expense.id === expenses.id ? expenses : expense) })
        })
    },
    deleteExpenses: (id) => {
        axios.delete(`expenses/${id}`).then(res => {
            set({ expenses: get().expenses.filter(expense => expense.id !== id) })
        })
    },
    columns: [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Foydalanuvchi',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Summa',
            dataIndex: 'summa',
            key: 'summa',
        },
        {
            title: 'Izoh',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Vaqti',
            dataIndex: 'created_at',
            key: 'created_at',
        }
    ],
}))